module.exports = __webpack_public_path__ + "static/media/ice-cream-4.e17f7570.png";